var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"splash-screen"},[_c('div',{staticClass:"splash-content"},[_c('div',{staticClass:"icon-box"},[_c('car-front-flat')],1),_c('p',{staticClass:"unavailable-description"},[_vm._v(_vm._s(_vm.$t('customerInfoStep.bookingBlockedMsg')))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }